<template>
  <el-container class="container" style="padding:0">
    <!-- 侧边栏 -->
    <el-aside width="200px" style="background: rgb(246, 248, 251);height:100%">
      <LeftBar :left-items="leftItems" :currentSelectLeftItemKey="currentSelectLeftItemKey" @selectChange="leftItemselectChange"/>
    </el-aside>
    <!-- 主要内容容器 -->
    <el-container style="position:relative;height:100%;display: flex;flex-direction: column;">
      <!-- 容器顶部筛选条件按钮 -->
      <div style="height: 60px;background: white;padding:0 20px;">
        <div v-for="item in leftItems" :key="item.key">
          <div v-show="currentSelectLeftItemKey==item.key" style="display: flex;justify-content: space-between;align-items: flex-end;">
            <CustomTool style="width:100%;" :default-date-area="contentMap[item.key].toolConfig.defaultDateArea" :column_mapper="contentMap[item.key].toolConfig.column_mapper" :show-time-area="contentMap[item.key].toolConfig.showTimeArea" :show-time="false" :show-refresh="false" :show-filter="contentMap[item.key].toolConfig.showFilter" :show-export="true" :filterArchiveData="contentMap[item.key].toolConfig.filterArchiveData" @filters="filterContentChange" @export="exportFinancial"/>
          </div>
        </div>
      </div>
        <div style="height: 100%;padding:20px 0px;overflow: scroll;background:white;">
          <custom-table
              ref="mytable"
              :table-id="6"
              @row-click="rowClick"
              :project-list-dl="tableData.projectList"

              :show-coloums-dl="tableData.showColoums"
              :column_mapper="tableData.column_mapper"
              :default-sort="getToolConfigValueFromContentMap.sort"
              @sort-change="sortChange"
              :sort-column-name-dl="tableData.sortColumnName"
              :sort-column-order-dl="tableData.sortColumnOrder"

              @current-change="currentChange"
              :totalnums-dl="tableData.totalnums"
              :pagesize-dl="tableData.pagesize"
              :page-number-dl="tableData.pageNumber"

              :fixed-columns="tableData.fixedList"

              :disableDrag="true"

              :sortable="true"

              :pagination="tableData.pagination"

              :is-loading-dl="tableData.detailLoading"
              :use-virtual="false"
              :row-hegit="0"

              :tableColumnCustomConfig="tableData.tableColumnCustomConfig"
              @unusualShow="unusualShow"
              :custom-tabel-height-offset="265"
          ></custom-table>
        </div>

    </el-container>
  </el-container>
</template>

<script>
import dayjs from 'dayjs';
import CustomTable from "@/component/CustomTable";
import CustomTool from "@/component/Performance/topTool/CustomTool";
import CustomCard from "@/component/Performance/CustomCard";
import CustomDialog from "@/component/Performance/dialog/CustomDialog";
import LeftBar from "@/component/Bar/leftBar/LeftBar";
import {
  exportFinancial,
  exportTodoList,
  getFinancial,
  getTodoList,
  getTodoListCount,
  getUnusualList
} from '../../api/api'
import {getMonthStartDate} from "@/utils/util";
export default {
  name: "FinanceDept",
  props:["refreshId"],
  components:{
    CustomTable,
    CustomTool,
    CustomCard,
    CustomDialog,
    LeftBar
  },
  data(){
    return {
      tableData:{
        //表格列表相关
        detailLoading: false,
        projectList: [],//表格列表所有数据
        showProjectList:[],//显示的数据
        column_mapper: {},//表头所有列的枚举
        showColoums: [],//当前显示的表头列
        sortColumnName: "",//需要排序的列名
        sortColumnOrder: "",//排序的命令
        totalnums: 10,//所有的数据条数
        pageNumber: 1,//当前页
        fixedList: ['project:project_id', 'project:project_name'],
        pagesize: 10,//一页数据的行数（公用）
        pagination:true,
        tableColumnCustomConfig:{//图表某些列定制化显示
          'project:project_id':{
            type:"popover",
            showRule:{
              key:"project:project_remark",
              value:"异常"
            },
            project_id:"",
            closeTime:1,
            openTime:0,
            forceClose:false,
            show:false,
            popoverDatas:[]
          }
        }
      },
      leftItems: [
        {
          id: 0,
          name: "订单基本库",
          key: "project"
        },
        {
          id:1,
          name:"自2020年累计至今在手订单明细",
          key:"unfinished_quotation"
        },
        {
          id:2,
          name:"采购打款明细",
          key:"purchase_charge"
        }

      ],
      currentSelectLeftItemKey:"project",
      contentMap:{
        "project":{
          toolConfig:{
            sort:{},
            showFilter:false,
            showTimeArea:false,
            column_mapper:{
            },
            filterContent:{
              queryCond: [],
              sortCond: {
                columnName: "",
                value: ""
              },
              timerange:{
                start:"",
                end:""
              }
            },
            defaultDateArea:{
              defaultStart:"",
              defaultEnd:""
            },
            filterArchiveData:{
              start_end_date_dynamic:[],
              queryCond: []
            }
          }
        },
        "unfinished_quotation":{
          toolConfig:{
            sort:{},
            showFilter:false,
            showTimeArea:false,
            column_mapper:{
            },
            filterContent:{
              queryCond: [],
              sortCond: {
                columnName: "",
                value: ""
              },
              timerange:{
                start:"",
                end:""
              }
            },
            defaultDateArea:{
              defaultStart:"",
              defaultEnd:""
            },
            filterArchiveData:{
              start_end_date_dynamic:[],
              queryCond: []
            }
          }
        }
        ,
        "purchase_charge":{
          toolConfig:{
            sort:{},
            showFilter:true,
            showTimeArea:true,

            column_mapper:{
              "client_name": "客户名称:varchar",
              "client_region": "客户地区:varchar",
              "object": "对方名称:varchar",
              "project_id": "订单编号:varchar",
              "project_name": "订单名称:varchar",
              "purchase_type": "采购类型:varchar",
              "quotation_type": "计价类型:varchar",
            },
            filterContent:{
              queryCond: [],
              sortCond: {
                columnName: "",
                value: ""
              },
              timerange:{
                start:dayjs().startOf('month').format('YYYY-MM-DD'),
                end:""
              }
            },
            defaultDateArea:{
              defaultStart:dayjs().startOf('month').format('YYYY-MM-DD'),
              defaultEnd:""
            },
            filterArchiveData:{
              start_end_date_dynamic:[],
              queryCond: []
            }
          }
        }
      },

      filterRequestData:{},
      dialogFormVisible:false,

      showTimeArea:true
    }
  },
  async mounted() {
    window.vm4 = this
    this.refresh()
  },
  computed:{
    getToolConfigValueFromContentMap(){
      console.log('currentSelectLeftItemKey',this.currentSelectLeftItemKey)
      return this.contentMap[this.currentSelectLeftItemKey].toolConfig
    },
  },
  watch:{
    refreshId(newVal){
      console.log('refreshId change,刷新todoList',newVal)
      this.refresh(false)
    },
  },

  methods:{
    filterContentChange(content){
      console.log('filterContentChange',content)
      Object.assign(this.getToolConfigValueFromContentMap.filterContent,content)
      this.refresh()
      // this.getPerformanceData()
    },

    sortChange(e) {
      console.log('sortChange',e)

      if (e.order === null) {
        this.getToolConfigValueFromContentMap.filterContent.sortCond.columnName = ""
        this.getToolConfigValueFromContentMap.filterContent.sortCond.value = ""
      } else {
        this.getToolConfigValueFromContentMap.filterContent.sortCond.columnName  = e.prop
        if (e.order === 'ascending') {
          this.getToolConfigValueFromContentMap.filterContent.sortCond.value = 'asc'
        } else {
          this.getToolConfigValueFromContentMap.filterContent.sortCond.value = 'desc'
        }
      }
      this.getToolConfigValueFromContentMap.sort=e
      this.refresh()
    },

    async exportFinancial(){
      let param = {
        division:this.currentSelectLeftItemKey,
        ...this.getToolConfigValueFromContentMap.filterContent
        // menu: "overview",
        // ...this.filterRequestData
      }
      console.log('exportFinancial/param',param)
      let loadingInstance = this.$loading.service({fullscreen: true, text: '请等待导出'});
      try {
        let {data} = await exportFinancial(param)
        loadingInstance.close();
        const blob = new Blob([data])
        var date = new Date()
        let Y = date.getFullYear().toString()
        let M = (date.getMonth() + 1).toString().padStart(2, "0")
        let D = date.getDate().toString().padStart(2, "0")
        let H = date.getHours().toString().padStart(2, "0")
        let m = date.getMinutes().toString().padStart(2, "0")
        let s = date.getSeconds().toString().padStart(2, "0")
        let fileName = this.leftItems.find(i=>i.key==this.currentSelectLeftItemKey).name + '-' + Y + M + D + H + m + s + ".xlsx"

        const link = document.createElement('a')
        link.download = fileName // a标签添加属性
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        document.body.appendChild(link)
        link.click() // 执行下载
        URL.revokeObjectURL(link.href) // 释放url
        document.body.removeChild(link) // 释
      } catch (err) {
        loadingInstance.close();

        var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
        if (issafariBrowser) {
          this.$message.warning("暂不支持在Safari浏览器中导出，请使用其他浏览器")
        } else {
          this.$message.warning(`导出失败,请尝试使用其他浏览器,错误信息(${err})`)
        }


      }

    },

    async unusualShow(project_id){
      let res = await getUnusualList({project_id: project_id})
      let resData = res.data

      if (resData.hasOwnProperty('respCode')) {
        if (resData.respCode == "000000") {
          this.tableData.tableColumnCustomConfig['project:project_id'].project_id = project_id
          this.tableData.tableColumnCustomConfig['project:project_id'].popoverDatas = resData.respData
        } else {
          this.$message.warning(resData.respMsg)
        }
      } else {
        this.$message.error("数据有误")
      }
    },

    /**
     * 表格某行点击
     * @param e 点击item数据
     */
    rowClick(e) {
      // console.log('rowClick', e['project:project_name'])
      // this.$store.commit("setProjectId", e["project:project_id"]);
      // this.$store.commit("setProjectInfo", {
      //   projectId: e["project:project_id"],
      //   projectName: e["project:project_name"],
      //   accu: 0
      // })
    },

    async currentChange(e) {
      console.log('currentChange',e)
      this.tableData.pageNumber = e;
      this.refresh(false)
    },

    shourtcutSelectChange(key){
      this.contentMap[this.currentSelectLeftItemKey].selectShortcutId = key
      this.refresh()
    },

    async leftItemselectChange(key){
      console.log('左侧item切换',key)
      this.currentSelectLeftItemKey = key
      await this.refresh()
      if(this.getToolConfigValueFromContentMap.sort.hasOwnProperty('prop')){
        this.$refs.mytable.sort(this.getToolConfigValueFromContentMap.sort.prop,this.getToolConfigValueFromContentMap.sort.order)
      }
    },



    async getFinancial(resetPage=false){
      if(resetPage){
        this.tableData.pageNumber = 1
      }
      console.log(this.currentSelectLeftItemKey,'this.getToolConfigValueFromContentMap.filterContent',this.getToolConfigValueFromContentMap.filterContent)
        this.filterRequestData = {
          division:this.currentSelectLeftItemKey,
          pagiInfo: {
            currentPage: this.tableData.pageNumber,
            pagesize: this.tableData.pagesize
          },
          ...this.getToolConfigValueFromContentMap.filterContent
        }
        let postData = this.filterRequestData
        // console.log('getFinancial/postData', postData)
        let res = await getFinancial(postData)
        let resData = res.data
        const {respData: {cols_mapper, data , columns_list,totalnums}} = resData
        // console.log('getFinancial返回结果', resData,cols_mapper,data,columns_list)
        this.tableData.column_mapper = cols_mapper
        this.tableData.projectList = data
        this.tableData.totalnums =  totalnums
        this.tableData.showColoums = columns_list
        // console.log('this.tableData.showColoums',this.tableData.showColoums )


          this.$nextTick(() => {
            this.tableData.detailLoading = false
          })



    },

    async refresh(resetPage=true){
      this.tableData.detailLoading = true
      await this.getFinancial(resetPage)
    }
  }
}
</script>
<style lang="scss">
.el-row {
  margin-bottom: 40px;
&:last-child {
   margin-bottom: 0;
 }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  height:200px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>

